var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRevisarDescricao01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_932",
    d: "M19,34.3H3.7c-0.5,0-0.8-0.4-0.8-0.8V7.2c0-0.3-0.2-0.5-0.5-0.5S1.9,6.9,1.9,7.2v26.3c0,1,0.8,1.9,1.9,1.9 H19c0.3,0,0.5-0.2,0.5-0.5C19.5,34.5,19.3,34.3,19,34.3C19,34.3,19,34.3,19,34.3L19,34.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_933",
    d: "M6.3,6h6.5c0.3,0,0.5-0.2,0.5-0.5C13.3,5.2,13,5,12.8,5H6.3C6,5,5.7,5.2,5.7,5.5C5.7,5.8,6,6,6.3,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_934",
    d: "M12.8,30.7c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5c0,0,0,0,0,0H6.3c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0H12.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_935",
    d: "M33.7,30.7l-5.2-5.2l0,0l-1.8-1.8c1.8-2.5,2.5-5.6,1.7-8.6c-0.1-0.3-0.4-0.4-0.6-0.4 c-0.3,0.1-0.4,0.3-0.4,0.6c1.2,5-1.8,10-6.8,11.3s-10-1.8-11.3-6.8c-0.8-3.2,0.2-6.5,2.5-8.8c3.6-3.6,9.5-3.6,13.2,0 c0.7,0.7,1.3,1.6,1.8,2.5c0.1,0.2,0.4,0.3,0.7,0.2c0.2-0.1,0.3-0.4,0.2-0.7c-0.3-0.6-0.6-1.1-1-1.6V2.5c0-1-0.8-1.9-1.9-1.9H3.7 c-1,0-1.9,0.8-1.9,1.9V5c0,0.3,0.2,0.5,0.5,0.5S2.9,5.3,2.9,5V2.5c0-0.5,0.4-0.8,0.8-0.8h21.1c0.5,0,0.8,0.4,0.8,0.8v7.7 c-4-4-10.6-4-14.6,0L11,10.3H7.8c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0h2.4c-0.3,0.4-0.6,0.8-0.8,1.3H6.3 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0h2.6c-0.2,0.4-0.3,0.8-0.4,1.3H6.3c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5h2c-0.9,5.6,2.9,10.9,8.6,11.8c2.7,0.4,5.5-0.2,7.8-1.9l1.1,1.1v6.5c0,0.5-0.4,0.8-0.8,0.8h-3.7 c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h3.7c1,0,1.9-0.8,1.9-1.9V28l4.8,4.8c0.6,0.6,1.6,0.6,2.2,0c0,0,0,0,0,0l0,0 C34.3,32.2,34.3,31.2,33.7,30.7C33.7,30.7,33.7,30.7,33.7,30.7L33.7,30.7z M25.7,24.8c0.1-0.1,0.2-0.2,0.3-0.4l1.3,1.4l-0.7,0.7 l-1.3-1.3C25.5,25,25.6,24.9,25.7,24.8L25.7,24.8z M33,32.1c-0.2,0.2-0.5,0.2-0.7,0l-4.9-4.9l0.7-0.7l4.9,4.9 C33.2,31.6,33.2,31.9,33,32.1L33,32.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_936",
    d: "M12.5,11.6c-3.2,3.2-3.2,8.5,0,11.7s8.5,3.2,11.7,0c3.2-3.2,3.2-8.5,0-11.7C21.1,8.4,15.9,8.4,12.5,11.6 C12.6,11.6,12.6,11.6,12.5,11.6z M23.6,22.7c-2.8,2.8-7.5,2.8-10.3,0s-2.8-7.5,0-10.3s7.5-2.8,10.3,0c1.4,1.4,2.1,3.2,2.1,5.2 C25.7,19.4,24.9,21.3,23.6,22.7L23.6,22.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRevisarDescricao01);
export default __webpack_public_path__ + "static/media/ico-revisar-descricao-01.5d9eea7c147e74db293feae7bc41f048.svg";
export { ForwardRef as ReactComponent };